export default __webpack_public_path__ + "static/bonheur-ab01ae68fd47ea50963dd30e93e44862.jpg";